<script>
  import ResultsNotes from './results-notes/results-notes.svelte';
  import ResultsTable from './results-table/results-table.svelte';
</script>

<style>
</style>

<template lang="pug" src="./results.pug"></template>
